<div class="property-search-container">
    <form (ngSubmit)="searchHandler()">
        <mat-form-field class="property-search">
            <input matInput placeholder="Search (Id/Address/Folio/GridicsId/GroupId)" type="text"
                [formControl]="searchString" />
        </mat-form-field>
    </form>

    <mat-checkbox class="property-search" (change)="updateCalculationResults()"
        [(ngModel)]="showResultsCalculatedWithParams">
        Show results calculated with parameters
    </mat-checkbox>
</div>

<div class="property-search-result-container" *ngIf="showPropertyRecord && propertyRecords">
    <table *ngIf="showPropertyRecord && propertyRecords.length" mat-table [dataSource]="propertyRecords"
        multiTemplateDataRows class="mat-elevation-z0">
        <ng-container matColumnDef="{{ column }}" *ngFor="let column of propertyRecordsColumns">
            <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
            <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
        </ng-container>
        <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let propertyRecord" class="actions-container">
                <mat-icon *ngIf="!propertyRecord.isCalculated" matTooltip="Calculate"
                    (click)="recalculateLastResult($event, propertyRecord)">play_arrow</mat-icon>
                <mat-icon *ngIf="propertyRecord.isCalculated" matTooltip="Recalculate"
                    (click)="recalculateLastResult($event, propertyRecord)">replay</mat-icon>
                <app-process-small-spinner class="recalc-small-spinner-prop-record" *ngIf="isRecalcWithPropertyRecord"
                    [isVisible]="isLoading"></app-process-small-spinner>
            </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="propertyRecordsColumnsToDisplay.length">
                <div class="example-element-detail" [ngClass]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <!-- Zoning codes versions (table) -->
                    <mat-table *ngIf="element.CalculationResults.length; else empty_table"
                        [dataSource]="element.CalculationResults" class="mat-elevation-z16" style="width: 100%">
                        <ng-container matColumnDef="{{ column }}" *ngFor="let column of zoningCodeVersionColumns">
                            <mat-header-cell *matHeaderCellDef> {{ column }} </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{ element.ZoningCodeVersion[column] }} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="ZoningAllowanceId" *ngIf="showResultsCalculatedWithParams">
                            <mat-header-cell *matHeaderCellDef> ZoningAllowanceId </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{ element.ZoningAllowanceId }} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Actions">
                            <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
                            <mat-cell *matCellDef="let element" class="actions-container">
                                <mat-icon matTooltip="Review" (click)="redirectToReview(element)">remove_red_eye
                                </mat-icon>
                                <mat-icon *ngIf="showRecalculateButton(element)" matTooltip="Recalculate"
                                    (click)="recalculateLastResult()">
                                    replay
                                </mat-icon>
                                <app-process-small-spinner class="recalc-small-spinner"
                                    *ngIf="!isRecalcWithPropertyRecord" [isVisible]="isLoading">
                                </app-process-small-spinner>
                                <mat-icon *ngIf="showResultsCalculatedWithParams && element.BuildingZoningAllowance"
                                    matTooltip="Calculation parameters"
                                    (click)="showCalculationParametersInfo($event, element.BuildingZoningAllowance)">
                                    view_list
                                </mat-icon>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="calculationResultsColumnsToDisplay"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: calculationResultsColumnsToDisplay"></mat-row>
                    </mat-table>

                    <ng-template #empty_table>
                        <p>No calculation results exist</p>
                    </ng-template>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="propertyRecordsColumnsToDisplay"></tr>
        <tr mat-row *matRowDef="let element; columns: propertyRecordsColumnsToDisplay" class="example-element-row"
            [class.example-expanded-row]="expandedElement === element" (click)="showCalculationResults(element)"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>

    <div *ngIf="showForceRecalculate" class="not-found-card">
        <app-spinner *ngIf="showSpinner; else notFound">
        </app-spinner>

        <ng-template #notFound>
            <p>Property records not found</p>
            <button mat-flat-button color="primary" (click)="tryForcedCalculate()">Try to find and calculate</button>
        </ng-template>
    </div>
</div>
